import { useCallback, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FormControl,
  TextField,
  Theme,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import {
  BottomActionArea,
  BottomActionButton,
  ExtraWhiteSpace,
  Header,
  NavigateBeforeButton,
  InputFieldWrapper,
  ContentContainer,
  Body,
} from "@components";
import { FormContainer } from "@styles/styled";
import { Suggestion } from "@interfaces";

const Input = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  fontSize: "1rem",
  fontWeight: 400,
  "& .MuiInputBase-root": {
    padding: "8px 12px",
    fontSize: "1rem",
    fontWeight: 400,
  },
  "& textarea": {
    minHeight: "200px",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

interface LocationState {
  attachedProcedures: Suggestion[];
  searchedQuery: string;
}

export function AddProcedureManually() {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const location = useLocation();
  const { attachedProcedures = [], searchedQuery = "" }: LocationState =
    location.state || {};

  const navigate = useNavigate();
  const { requestId = "" } = useParams();

  const [manuallyAddedProcedure, setManuallyAddedProcedure] =
    useState<Suggestion>({ text: searchedQuery, code: null });

  const handleBack = useCallback(() => {
    navigate(`/app/solicitudes/${requestId}/orden-medica/crear/buscar`, {
      state: { repeatedDocumentDetails: attachedProcedures },
    });
  }, [attachedProcedures, navigate, requestId]);

  const onSubmit = (manualProcedure: Suggestion) => {
    if (manualProcedure.text === "") return;
    const isProcedureAttached = attachedProcedures.some(
      (attachedProcedure) => attachedProcedure.text === manualProcedure.text
    );
    if (!isProcedureAttached) {
      attachedProcedures.push({
        text: manualProcedure.text,
        code: manualProcedure.code ?? null,
      });
    }
  };

  return (
    <>
      <Header
        title={isMobile ? "Agregar manualmente" : undefined}
        useMekiDocIcon={!isMobile}
        titleColor="black"
        left={<NavigateBeforeButton onClick={handleBack} />}
      />
      <ContentContainer disableGutters>
        <Body>
          <Title variant="h4" fontWeight={"medium"}>
            Agregar manualmente
          </Title>
          <FormContainer onSubmit={() => {}}>
            <InputFieldWrapper label="Detalle del examen o procedimiento">
              <FormControl fullWidth>
                <Input
                  multiline
                  value={manuallyAddedProcedure.text}
                  onChange={(e) =>
                    setManuallyAddedProcedure({
                      text: e.target.value,
                      code: null,
                    })
                  }
                />
              </FormControl>
            </InputFieldWrapper>
            <ExtraWhiteSpace />
            <BottomActionArea>
              <BottomActionButton
                onClick={() => {
                  onSubmit(manuallyAddedProcedure);
                  navigate(`/app/solicitudes/${requestId}/orden-medica/crear`, {
                    state: { repeatedDocumentDetails: attachedProcedures },
                  });
                }}
              >
                Siguiente
              </BottomActionButton>
            </BottomActionArea>
          </FormContainer>
        </Body>
      </ContentContainer>
    </>
  );
}
